module.exports = __webpack_public_path__ + "static/media/screen-iglu-search.b0a6c412.png";